// From https://stackoverflow.com/questions/9960908/permutations-in-javascript/9960925
export function permute<T>(input: ReadonlyArray<T>): T[][] {
	const input2 = [...input];
	const length = input2.length;
	const result = [input2.slice()];
	const c = new Array(length).fill(0);
	let i = 1;

	while (i < length) {
		if (c[i] < i) {
			const k = i % 2 && c[i];
			const p = input2[i];
			input2[i] = input2[k];
			input2[k] = p;
			++c[i];
			i = 1;
			result.push(input2.slice());
		} else {
			c[i] = 0;
			++i;
		}
	}

	return result;
}

export function ncg(input: string): string {
	return '(?:' + input + ')';
}

export function pla(input: string): string {
	return '(?=' + input + ')';
}

export function opt(input: string): string {
	return ncg(input) + '?';
}

export function star(input: string, lazy = false): string {
	return ncg(input) + '*' + (lazy ? '?' : '');
}

export function join(...input: string[]): string {
	return input.map(ncg).join('');
}

export function or(...input: string[]): string {
	return input.map(ncg).join('|');
}

export function or2(input: string[]): string {
	return input.map(ncg).join('|');
}

export function whole(...input: string[]): string {
	return '^' + ncg(join(...input)) + '$';
}

export function whole2(input: string[]): string {
	return '^' + ncg(join(...input)) + '$';
}

export function perm(...input: string[]): string {
	const options = permute(input).map(oneOption => join(...oneOption));
	const ord = or(...options);
	return ord;
}

export function perm2(input: string[]): string {
	const options = permute(input).map(oneOption => join(...oneOption));
	const ord = or(...options);
	return ord;
}

export function cont(...input: string[]): string {
	let extras = '';
	for (let i = input.length - 1; i > 0; i--) {
		extras = ncg(input[i] + extras) + '?';
	}
	return input[0] + extras;
}

export function wholeRx(...input: string[]): RegExp {
	return new RegExp(whole(...input));
}

export function wholeRx2(input: string, flags?: string): RegExp {
	return new RegExp(whole(input), flags);
}

export function anyPermutationRx(input: string[], flags?: string): RegExp {
	return new RegExp(whole(perm(...input)), flags);
}

export function bagOf(optional: string[], required?: string[]): RegExp {
	required = required ?? [];
	const all: string[] = [...new Set([...optional, ...required])];

	const chainOfWords = star(or2(all));

	return wholeRx(
		whole2([...required.map(s => pla(whole2([chainOfWords, s, chainOfWords]))), chainOfWords])
	);
}
